module.exports = __webpack_public_path__ + "static/media/parking_on.685e1683.svg";